export enum RouteName {
  List = 'users-list',
  Create = 'user-create',
  Details = 'user-details',
  Edit = 'user-edit',
}
